@if (form) {
  <form [formGroup]="form">
    <div>
      <div class="row" formArrayName="folders"><div class="form-group col-12 mb-0"><label>Name</label></div>
      @for (folder of foldersArray.controls; track folder; let i = $index) {
        <ng-container  [formGroupName]="i">
          <div class="form-group col-md-12 mr-1 s_no-label">
            <div class="input-group">
              <input id="folder-name{{i}}"
              [attr.data-test-id]="'subfolder-dialog-subfolder-name-input-' + i"
                type="text" formControlName="name"
                class="form-control"
                placeholder="Subfolder Name">
                <div class="input-group-append">
                  <button id="remove-folder-name{{i}}"
                    type="button"
                    class="mx-2 link-button s_ico s_ico-remove_fill"
                  (click)="removeFolderName(i)"></button>
                </div>
              </div>
            </div>
          </ng-container>
        }
      </div>
      @if (shouldShowAddSubfolderNameButton) {
        <button
        [attr.data-test-id]="'subfolder-dialog-add-button'"  
          id="add-folder-name"
          type="button"
          class="btn btn-sm btn-outline-primary s_edit mt-1 mb-3"
          (click)="addFolderName()"
        formnovalidate>+ ADD</button>
      }
    </div>
  </form>
}